const formatter = new Intl.NumberFormat('en', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/**
 * Formats a number using compact notation.
 *
 * @example
 * formatCompactNumber(999)     // "999"
 * formatCompactNumber(1100)    // "1.1K"
 * formatCompactNumber(2500000) // "2.5M"
 */
export const formatCompactNumber = (value: number): string =>
  formatter.format(value);
